import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://167.71.62.249/';
const API_URL_LAB = BASE_URL + 'lab/';
const API_URL_AUTH = BASE_URL + 'auth/';

const getAnalyses = (token) => {
  return axios.get(API_URL_LAB + 'anal-list', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getEndpoints = (token) => {
  return axios.get(API_URL_LAB + 'endpoints', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getEndpointDetail = (id, token) => {
  return axios.get(API_URL_LAB + `endpoints/${id}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getModels = (token) => {
  return axios.get(API_URL_LAB + 'mlmodels', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getModelsArray = (token, ids = []) => {
  // Construct the query parameters for the ids
  const queryParams = ids.length ? `?${ids.map(id => `ids[]=${id}`).join('&')}` : '';

  return axios.get(`${API_URL_LAB}mlmodels-array/${queryParams}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getMLModelsByEndpoint = (endpointId, token) => {
  return axios.get(`${API_URL_LAB}mlmodels/endpoint/${endpointId}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getAnalysisDetail = (id, token) => {
  return axios.get(API_URL_LAB + `analysis/${id}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const deleteAnalysis = (id, token) => {
  return axios.delete(API_URL_LAB + `analysis/${id}/delete`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
};

const getUserInfo = (token) => {
  return axios.get(API_URL_AUTH + 'user', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const startPrediction = (data, token) => {
  return axios.post(API_URL_LAB + 'start-pred', data, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
};

const getSelectModels = (pk, token) => {
  return axios.get(API_URL_LAB + `run-calc/${pk}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const runCalcPrediction = (pk, data, token) => {
  return axios.post(API_URL_LAB + `run-calc/${pk}`, data, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
};

const getModelDetails = (pk, token) => {
  return axios.get(API_URL_LAB + `mlmodels/${pk}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getSmilesImage = (pk, token) => {
  return axios.get(API_URL_LAB + `analysis-image/${pk}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getSmilesImage2 = (pk, token) => {
  return axios.get(API_URL_LAB + `analysis-image2/${pk}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const getSmilesImageList = (smilesList, token) => {
  return axios.post(
    API_URL_LAB + 'generate-images/',
    { smiles_list: smilesList },
    {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );
};

const getLeveragePlot = (pk, token) => {
  return axios.get(API_URL_LAB + `leverage-plot/${pk}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const checkComputationStatus = (pk, token) => {
  return axios.get(API_URL_LAB + `computation-status/${pk}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
};

const contactUs = (data, token) => {
  const config = token ? { headers: { 'Authorization': `Bearer ${token}` } } : {};
    return axios.post(API_URL_AUTH + 'contact-us/', data, config);
};

const redeemCoupon = (code, token) => {
  const config = token ? { headers: { 'Authorization': `Bearer ${token}` } } : {};
  return axios.post(API_URL_LAB + 'redeem-coupon/', { code }, config); 
};
const downloadReportsZip = (pk, token) => {
  return axios.get(API_URL_LAB + `analysis/${pk}/download-reports/`, {
    headers: {
      'Authorization': `Bearer ${token}`
    },
    responseType: 'blob', // BARDZO WAŻNE DLA POBIERANIA PLIKÓW!
  });
};

export default {
  getAnalyses,
  getAnalysisDetail,
  deleteAnalysis,
  getUserInfo,
  startPrediction,
  getSelectModels,
  runCalcPrediction,
  getModelDetails,
  getSmilesImage,
  getSmilesImage2,
  checkComputationStatus,
  getEndpoints,
  getEndpointDetail,
  getMLModelsByEndpoint,
  getModels,
  getModelsArray,
  getSmilesImageList,
  getLeveragePlot,
  contactUs,
  redeemCoupon,
  downloadReportsZip
};
